import React, {useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { Routes, Route } from "react-router-dom";
import TokenCreate from "./pages/token-create";
import MyToken from "./pages/my-token";
import Airdrop from "./pages/airdrop";
import Header from "./components/Header";
import { I18nProvider, useI18n } from './contexts/I18nContext';
import { IntlProvider, FormattedMessage } from 'react-intl';
import enMessages from './locales/en.json';
import zhMessages from './locales/zh.json';
import { LanguageSwitcher } from './components/LanguageSwitcher';


const AppContent = () => {
  // const { t, translating, language } = useI18n();
  // let myName: string = '欢迎使用我们的服务';
  // let youName:string = '这是一个演示自动翻译的React应用'
  

  return (
    <>
      <Header />
      {/* <LanguageSwitcher /> */}
        <Routes>
          <Route path="/" element={<TokenCreate />} />
          <Route path="/my-token" element={<MyToken />} />
          <Route path="/airdrop" element={<Airdrop />} />
          </Routes>
      
    </>
  );
};


function App() {

  const [locale, setLocale] = useState('en');

  return (
    <>
      <I18nProvider>
        <AppContent/>
      </I18nProvider>
    </>
  );
}

export default App;
